import { render, staticRenderFns } from "./SliderSection.vue?vue&type=template&id=4b8cebfd&scoped=true"
import script from "./SliderSection.vue?vue&type=script&lang=js"
export * from "./SliderSection.vue?vue&type=script&lang=js"
import style0 from "./SliderSection.vue?vue&type=style&index=0&id=4b8cebfd&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4b8cebfd",
  null
  
)

export default component.exports